// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPalette.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { take, chunk, flow, isArray, isInteger, fill, get, isNil } from 'lodash/fp';
import Color from './Izenda.Color';
import classnames from 'classnames';

/**
 * Color Palette component
 */
@connect({ toClass: true })
export default class ColorPalette extends Component {
  static MaxColorCount = 12;
  static ColumnCount = 6;
  static Cols = 2;

  renderColorsCol = (rowIndex, colors) => {
    return colors.map((color, index) => (
      <GridLayout.Col
        cols={ColorPalette.Cols}
        xs={ColorPalette.Cols}
        key={`${rowIndex}_${index}`}
        className="u_noPaddingAll izenda-ColorPalette-Col"
      >
        <Color value={color} />
      </GridLayout.Col>
    ));
  };

  renderColorsRow = colors => {
    const paddingArray = newLength => source => {
      if (isArray(source) && isInteger(newLength)) {
        const addingItemsCount = newLength - source.length;
        const addingItems =
          addingItemsCount > 0 ? fill(0, addingItemsCount, null, Array(addingItemsCount)) : new Array();
        return source.concat(addingItems);
      }
      return null;
    };

    const rows = flow(
      paddingArray(ColorPalette.MaxColorCount),
      take(ColorPalette.MaxColorCount),
      chunk(ColorPalette.ColumnCount)
    )(colors);

    return rows.map((colorsRow, index) => (
      <GridLayout.Row key={index} className="u_noMarginAll">
        {this.renderColorsCol(index, colorsRow)}
      </GridLayout.Row>
    ));
  };

  render() {
    const {
      selected,
      className,
      isDefaultTheme,
      localization,
      displaySettingStatus
    } = this.props;

    const displayName = get('model.displayName', this.props);
    const isDisplayDefaultText = displaySettingStatus && isDefaultTheme;
    const defaultText = isDisplayDefaultText ? `(${localization.getText('COLORPALETTE_DEFAULT')})` : '';
    const colors = get('model.colors', this.props);
    const classNames = classnames('izenda-ColorPalette', className, {
      'izenda-ColorPalette-selected': selected
    });

    return (
      <GridLayout className={classNames}>
        <GridLayout.Row className="u_noMarginAll izenda-ColorPalette-InforRowContainer">
          <div className="u_textTruncate" title={`${displayName} ${defaultText}`}>
            {displayName}
            {isDisplayDefaultText && (
              <small className="u_marginLeftInnerSpace">{defaultText}</small>
            )}
          </div>
        </GridLayout.Row>
        {colors && (
          <GridLayout.Row className="u_noMarginAll izenda-ColorPalette-ColorRowsContainer">
            {this.renderColorsRow(colors)}
          </GridLayout.Row>
        )}
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorPalette/Izenda.ColorPalette.js